import { CardContent, Grid } from "@mui/material";
import React from "react";
import Logo from "../../../assets/images/logo_medium.png";
import ChangePass from "../../commons/setPassword/setPassword";
import { StyledChangePasswordContainer } from "../../styled/changePassword";
import LoginFooter from "../login/loginFooter";

const ChangePasswordContainer = () => {
  return (
    <StyledChangePasswordContainer.GridContainer
      container
      justifyContent="center">
      <StyledChangePasswordContainer.LoginContainer item xs={4}>
        <StyledChangePasswordContainer.LoginCard>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              direction="column">
              <StyledChangePasswordContainer.LogoImage src={Logo} alt="Logo" />
            </Grid>
            <StyledChangePasswordContainer.Text>
              Cambiar contraseña
            </StyledChangePasswordContainer.Text>
            <ChangePass type="ResetPassword" />
          </CardContent>
          <LoginFooter loginAccount />
        </StyledChangePasswordContainer.LoginCard>
      </StyledChangePasswordContainer.LoginContainer>
    </StyledChangePasswordContainer.GridContainer>
  );
};

export default ChangePasswordContainer;
